<template>
  <div v-if="isLoading" class="text-xs-center py-5">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
  <v-card v-else-if="!isLoading && items.length">
    <v-card-text :style="{ overflow: 'auto' }">
      <table class="change-log-table">
        <thead>
          <tr>
            <th>{{ $t('Date') }}</th>
            <th>{{ $t('editor') }}</th>
            <th>{{ $t('data_field') }}</th>
            <th>{{ $t('before_edit') }}</th>
            <th>{{ $t('after_edit') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in items">
            <tr
              v-for="(editField, editFieldIndex) in item.edit_field_list.data"
              :key="`${item.id}-${editField.field_name}`"
            >
              <template v-if="editFieldIndex === 0">
                <td :rowspan="item.edit_field_list.data.length">
                  {{ item.edited_at | DateFormat('DD/MM/YY HH:mm') }}
                </td>
                <td :rowspan="item.edit_field_list.data.length">{{ item.edited_by }}</td>
              </template>
              <td>{{ readableFieldName(editField.field_name) }}</td>
              <td>{{ readableFieldValue(editField.before, editField.field_name) }}</td>
              <td>{{ readableFieldValue(editField.after, editField.field_name) }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <v-pagination
        :value="filters.page"
        :total-visible="6"
        :length="Math.ceil(total / filters.limit)"
        class="mx-auto"
        @input="filters = { ...filters, page: $event }"
      ></v-pagination>
    </v-card-actions>
  </v-card>
  <div v-else class="text-xs-center grey lighten-3 py-3 my-3" style="border-radius: 8px">
    - ไม่มีประวัติการแก้ไข -
  </div>
</template>

<script>
import tremendousApi from '@/api/tremendous'
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isLoading: true,
      items: [],
      total: 0,
      filters: {
        page: 1,
        limit: 10
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    branchOptions() {
      return (
        this.$store.state.tremendousMasterData.branch.map((el) => {
          return { name: el.branch_name, id: el.id }
        }) || []
      )
    }
  },
  watch: {
    filters: {
      immediate: true,
      handler() {
        this.fetchItems()
      }
    }
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const request = await tremendousApi.getEditHistoryLog({
          pageId: this.selectedBot.pageid,
          config: {
            params: {
              limit: this.filters.limit,
              offset: (this.filters.page - 1) * this.filters.limit,
              member_id: this.$route.params.id
            }
          }
        })

        if (request.status === 200) {
          this.items = request.data.data
          this.total = request.data.total
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.isLoading = false
      }
    },
    readableFieldName(value) {
      return (
        {
          full_name: this.$t('full_name'),
          customer_type: this.$t('customer_type'),
          email: this.$t('email'),
          phone_number: this.$t('phone_number'),
          branch_id: this.$t('branch'),
          pledge_water_tank: this.$t('pledge_water_tank'),
          total_pledge_water_tank: this.$t('total_pledge_water_tank'),
          file_url: this.$t('upload_file'),
          address_lat: this.$t('latitude'),
          address_long: this.$t('longitude')
        }[value] || ''
      )
    },
    readableFieldValue(value, field) {
      if (field === 'branch_id') {
        return (this.branchOptions.find((option) => option.id === value) || {}).name || ''
      }
      if (field === 'pledge_water_tank') {
        return value ? 'มี' : 'ไม่มี'
      }
      if (field === 'file_url') {
        return value === '[]' ? '' : value
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
.change-log-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #9e9e9e;
    padding: 4px;
    text-align: left;
  }

  th {
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/Tremendous/ChangeLog.vue